<template>
  <div class="deactivated-container">
    <div class="deactivated-content">
      <div class="deactivated-icon">
        <div class="icon-x"></div>
      </div>
      
      <h2 class="deactivated-title">{{ title }}</h2>
      <p class="deactivated-message"><strong>{{ message }}</strong></p>
      
      <p class="support-email"><strong>Email:</strong> <a href="mailto:support@projectblue.com" class="email-link">support@projectblue.com</a></p>

      <div class="action-buttons mt-4">
        <a href="/" class="btn-return-login">Return to Login</a>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_FAILURE_REASONS } from "@/constants/auth";

export default {
  name: 'AuthFailure',
  computed: {
    failureType() {
      return this.$route.query.type || AUTH_FAILURE_REASONS.DEACTIVATED;
    },
    title() {
      switch (this.failureType) {
        case AUTH_FAILURE_REASONS.EMAIL_MISMATCH:
          return "Email Mismatch";
        case AUTH_FAILURE_REASONS.ORGANIZATION_RESTRICTION:
          return "Organization Restriction";
        case AUTH_FAILURE_REASONS.EXPIRED_INVITE:
          return "Invitation Expired";
        case AUTH_FAILURE_REASONS.SIGNIN_FAILURE:
          return "Sign-In Error";
        case AUTH_FAILURE_REASONS.DEACTIVATED:
        default:
          return "Account Deactivated";
      }
    },
    message() {
      switch (this.failureType) {
        case AUTH_FAILURE_REASONS.EMAIL_MISMATCH:
          return "The email account you signed in with does not match the invitation. Please sign in with the exact email address that received the invitation.";
        case AUTH_FAILURE_REASONS.ORGANIZATION_RESTRICTION:
          return "Self-service sign-in/up is restricted for your organization. Please contact your organization administrator.";
        case AUTH_FAILURE_REASONS.EXPIRED_INVITE:
          return "Your invitation link has expired or has already been used. Please request a new invite.";
        case AUTH_FAILURE_REASONS.SIGNIN_FAILURE:
          return "We were unable to complete your sign-in. Please try again or contact our support team below.";
        case AUTH_FAILURE_REASONS.DEACTIVATED:
        default:
          return "Your account has been deactivated or not yet provisioned. Please contact our support team below.";
      }
    }
  }
}
</script>

<style scoped>
/* Ensure all text elements use Gilroy font and black color */
.deactivated-container * {
  color: #000000 !important;
  font-family: 'Gilroy', sans-serif !important;
}

.deactivated-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 20px;
  font-family: 'Gilroy', sans-serif !important;
  font-weight: 500;
}

.deactivated-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  font-family: 'Gilroy', sans-serif !important;
}

.deactivated-title {
  color: #000000;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 30px;
}

.deactivated-icon {
  width: 80px;
  height: 80px;
  background: #718096;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px auto;
}

.icon-x {
  position: relative;
  width: 30px;
  height: 30px;
}

.icon-x::before,
.icon-x::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 3px;
  background-color: white;
  border-radius: 2px;
}

.icon-x::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.icon-x::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.deactivated-message {
  color: #000000 !important;
  font-family: 'Gilroy', sans-serif !important;
  font-size: 1.1rem;
  margin-bottom: 30px;
  line-height: 1.6;
  font-weight: 500;
}

.support-email {
  color: #000000 !important;
  font-family: 'Gilroy', sans-serif !important;
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: 500;
}

.email-link {
  color: #000000 !important;
  font-family: 'Gilroy', sans-serif !important;
  text-decoration: none;
  font-weight: 500;
}

.email-link:hover {
  text-decoration: underline;
}

.btn-return-login {
  display: inline-block;
  padding: 10px 24px;
  background: linear-gradient(to right, #213ce5, #2380f2);
  color: #ffffff !important;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  margin-top: 15px;
  transition: opacity 0.2s;
}

.btn-return-login:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .deactivated-content {
    padding: 20px;
    margin: 10px;
  }
  
  .deactivated-title {
    font-size: 1.5rem;
  }
  
  .deactivated-icon {
    width: 60px;
    height: 60px;
  }
  
  .icon-x {
    width: 20px;
    height: 20px;
  }
  
  .icon-x::before,
  .icon-x::after {
    width: 15px;
    height: 2px;
  }
}
</style>
